import { Component, Input } from '@angular/core';

import { Client } from '../models/client.model';
import { Politician } from '../models/politician.model';

@Component({
  selector: 'app-socials',
  templateUrl: './socials.component.html',
  styleUrls: ['./socials.component.scss'],
  standalone: false
})

export class SocialsComponent {
  @Input() item: Politician | Client | any;
  @Input() side: string;
  @Input() text: string;

  constructor() { }

}
